const timeout = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export const getGoogleTag = async () => {
  while (typeof googletag === 'undefined' || !googletag.apiReady) {
    await timeout(250);
  }
  return true;
};

export const getPubAds = async () => {
  if (typeof googletag !== 'undefined' && googletag.pubadsReady) {
    return true;
  }
  else {
    return await setTimeout(getPubAds, 250);
  }
};

const getReferrerDomain = () => {
  const domain = window.document.referrer.split('/')[2];
  if (!domain) {
    return '';
  }
  return domain.replace(/^www\./,'');
};

const getReferrerUrlPath = () => {
  const referrerValues = window.document.referrer.split('/');
  if(referrerValues.length <= 3) return '';
  return referrerValues.splice(3).join('/');
};

export const setupDFP = async () => {
  await getGoogleTag();

  googletag.cmd.push(() => {
    const service = googletag.pubads();
    service.enableSingleRequest(false);
    service.collapseEmptyDivs(true);
    googletag.enableServices();
  });
};

export const updateGoogleTagsForDFP = async (isActive, community = 'none', postId = 'none', tagArray = [], pageType) => {
  await getGoogleTag();
  const referrerDomain  = getReferrerDomain();
  const referrerUrlPath = getReferrerUrlPath();
  const branch          = window.HU_TEST_BRANCH;

  googletag.cmd.push(() => {
    const service = googletag.pubads();
    googletag.pubads()
      .setTargeting('user', isActive ? 'member' : 'visitor')
      .setTargeting('branch', branch)
      .setTargeting('community', community)
      .setTargeting('post-id', postId)
      .setTargeting('terms', tagArray)
      .setTargeting('source-domain', referrerDomain)
      .setTargeting('source-page', referrerUrlPath)
      .setTargeting('page-type', pageType);
    service.refresh();
  });
};



// WEBPACK FOOTER //
// ./src/utils/adverts.js